import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Liberazione dal Carico Mentale',
    desc: 'Scegli il modulo, segui la scheda e allena. La pianificazione è risolta.'
  }, {
    emoji: '👑',
    title: 'Autorità e Sicurezza',
    desc: 'Arriva in palestra con la postura di un esperto e le parole giuste per guidare il gruppo.'
  }, {
    emoji: '📈',
    title: 'Progressione Reale degli Atleti',
    desc: 'Sequenze biomeccanicamente corrette affinché i tuoi giocatori notino risultati reali.'
  }, {
    emoji: '😌',
    title: 'Zero Stress da Improvvisazione',
    desc: "Domina l'arte dei passaggi tra esercizi per un flusso perfetto che impressionerà la tua società."
  }];
  return <section className="bg-volley-paper py-24 px-4 sm:px-6 lg:px-8" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <div className="bg-volley-teal/10 text-volley-teal-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-17">
            COSA CAMBIERÀ
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-volley-dark leading-tight mb-4 tracking-tight" data-id="element-18">
            Cosa cambierà nella tua{' '}
            <span className="italic text-volley-orange" data-id="element-19">
              vita professionale
            </span>
          </h2>
          <p className="text-volley-slate text-lg max-w-2xl mx-auto" data-id="element-20">
            Benefici reali a partire dalla prima settimana:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-21">
          {benefits.map((b, idx) => <div key={idx} className="bg-white rounded-3xl p-8 border border-volley-navy/5 hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-22">
              <div className="text-4xl mb-4" data-id="element-23">{b.emoji}</div>
              <h3 className="font-display font-semibold text-volley-navy text-xl mb-3 leading-tight" data-id="element-24">
                {b.title}
              </h3>
              <p className="text-volley-slate text-base leading-relaxed" data-id="element-25">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}